define('bizzabo/views/right/EditTiersView',[
    'jquery',
    'jquery-colorpicker',
    'backbone',
    'underscore',
    'bizzabo/utils',
    'bizzabo/consts',
    'bizzabo/models/Global',
    'bizzabo/views/FormMixin',
    'bizzabo/views/ModelBindingMixin',
    'hbars!bizzabo/templates/editTiers'
], function(
    $,
    jQuerySimpleColorPicker,
    Backbone,
    _,
    UTILS,
    Consts,
    Global,
    FormMixin,
    ModelBindingMixin,
    template
    ) {

    var EditTiersView = Backbone.View.extend({
        tagName : "article",
        className : "editTiersDetails possibleScroll",

        tierSubViews : {},

        events : {
            'click .add-tier': 'addTierClicked'
        },

        initialize : function() {
            Backbone.on(Consts.Notifications.rightPanel.SWITCHED, this.onReady, this);
        },

        remove : function() {
            Backbone.off(Consts.Notifications.rightPanel.SWITCHED, this.onReady, this);
            this.removeSubViews();
            this.off();
            this.$el.remove();
        },

        addTierClicked: function() {
            var tiers = this.model.get('tier-configuration');
            var index = (tiers.length + 1);
            tiers.add({
                tier : index,
                label : "Tier " + index,
                color : "aedda6"
            });
            this.addItemView(tiers.last());
        },

        addItemView: function(tier) {
            var itemView = new EditTiersItemView({
                model : tier
            });

            this.tierSubViews[itemView.cid] = itemView;
            itemView.render();
            this.$('.tierList').append(itemView.el);
            itemView.rendered && itemView.rendered();
        },

        renderTiers : function() {
            var thisView = this;
            var tiers = this.model.get('tier-configuration');
            tiers.each(this.addItemView, this);
        },

        removeSubViews: function() {
            for (var cid in this.tierSubViews) {
                this.tierSubViews[cid].remove();
            }
            this.tierSubViews = [];
        },

        render : function() {
            var html = template({
                mainTemplate : true
            });
            this.$el.html(html);

            return this;
        },

        onReady : function() {
            this.renderTiers();
        }
    });

    var EditTiersItemView = Backbone.View.extend({

        events : {
            'change input[name=label]' : 'labelChanged'
        },

        initialize : function() {
            this.initializeForm();
            this.model.on('color', this.renderColor, this);
        },

        initializeForm : function() {
            var fields = ['label'];
            this.keyPressValidationFields = fields;
            this.modelBindingWhiteList = fields;
            this.bindAllValidationFields = false;
            this.disableChosen = true;

            UTILS.mixIntoMe(this, FormMixin);
            UTILS.mixIntoMe(this, ModelBindingMixin);
            this.initModelBinding();
            this.initValidation();
        },

        remove : function() {
            this.model.off('color', this.renderColor, this);
            this.removeForm();

            var colorPicker = this.$('select[name="colorpicker"]');
            colorPicker.simplecolorpicker('destroy');

            this.off();
            this.$el.remove();
        },

        removeForm : function() {
            this.removeModelBinding();
            this.removeValidation();
        },

        labelChanged : function() {
            var newValue = this.$('input[name=label]').val();
            this.model.set('label', newValue);
        },

        colorChanged : function() {
            var newValue = this.$('select[name="colorpicker"]').val().replace('#', '');
            this.model.set('color', newValue);
        },

        renderColor : function() {
            this.$('select[name="colorpicker"]').val('#' + this.model.get('color'));
        },

        renderColorPicker : function() {
            var thisView = this;
            var colorPicker = this.$('select[name="colorpicker"]');
            var currentColorExist = this.$('select[name="colorpicker"] option[value="#' + this.model.get('color') + '"]').length !== 0;
            if (!currentColorExist) {
                colorPicker.prepend('<option value="#' + this.model.get('color') + '">Custom</option>');
            }
            this.renderColor();
            colorPicker.simplecolorpicker({
                picker : true
            }).change(function() {
                    thisView.colorChanged();
                });
        },

        render : function() {
            var html = template(_.extend(this.model.toJSON(), {
                tierTemplate : true
            }));
            this.$el.html(html);

            this.renderForm();
            this.renderColorPicker();

            return this;
        },

        rendered : function() {
            this.$(".simplecolorpicker").attr("title", "Change color");
            $(".picker").find("div").removeAttr("title");
        }
    });

    return EditTiersView;

});
